import { gql } from '@apollo/client';

export const GET_JOB = gql`
  query getTaskById($id: String!) {
    getTaskById(id: $id) {
      id
      subCategory
      jobDate
      status
      description
      booking {
        id
        referenceNumber
        bookingCategory
        customer {
          id
          firstName
          lastName
          email
          phoneNumber {
            phone
          }
        }
      }
      driverType
    }
  }
`;